module.exports = __webpack_public_path__ + "img/SketchPngadc841dac17cf5aa8eb4d24afe37e6dfa4be96214779aef3c62050aa6dfcdb59.7f044848.png";